module.exports = __webpack_public_path__ + "img/toduba_logo.bf9f4c5a.jpg";